<!--<img src="https://tpc.googlesyndication.com/simgad/14490683507191221325" border="0" width="266" height="302" alt="" class="img_ad">-->
@if (showSortOptions) {
  <sort></sort>
}
<div>
  <ng-container *ngTemplateOutlet="Pagination; context: { isTop: true }"></ng-container>
</div>
@if ((items && items.length)) {
<div class="{{ displayItemsMode }} row row-cols-1" [ngClass]="[sharedSvc.isMobileMode() ? 'mobile-mode' : '',
             displayItemsMode == 'grid' ? 'g-4 row-cols-xxl-' + productItemsInRowOnGridMode.xxl +
                                             ' row-cols-xl-'+productItemsInRowOnGridMode.xl+
                                             ' row-cols-lg-'+productItemsInRowOnGridMode.lg+
                                             ' row-cols-md-'+productItemsInRowOnGridMode.md+
                                             ' row-cols-sm-'+productItemsInRowOnGridMode.sm+
                                             ' row-cols-xs-'+productItemsInRowOnGridMode.xs: '1']">
    @for (item of items; track item; let index = $index; let last = $last) {
      @for (block of blocks; track block) {
        @if (group&&block.ngxComponent&&index==block.ngxComponentPosition) {
          <div [ngClass]="'box-size-' + block.ngxBoxSize" class="group-component card g-item-card" [innerHTML]="block.ngxComponent | safe: 'html'"></div>
        }
        @if (last&&group&&block.ngxComponent&&index<block.ngxComponentPosition) {
          <div [ngClass]="'box-size-' + block.ngxBoxSize" class="group-component card g-item-card" [innerHTML]="block.ngxComponent | safe: 'html'"></div>
        }
      }
      @for (campaignData of campaignsData; track campaignData) {
        @if (campaignData && campaignData.ngxComponent && index==campaignData.ngxComponentPosition) {
          <div [ngClass]="'box-size-' + campaignData.ngxBoxSize" class="group-component card g-item-card" [innerHTML]="campaignData.ngxComponent | safe: 'html'"></div>
        }
        @if (last && campaignData && campaignData.ngxComponent && index < campaignData.ngxComponentPosition) {
          <div [ngClass]="'box-size-' + campaignData.ngxBoxSize" class="group-component card g-item-card" [innerHTML]="campaignData.ngxComponent | safe: 'html'"></div>
        }
      }
      @if (!item.isFamily && !item.isBucket) {
        <product-card #productCard class="col d-flex justify-content-center" [ngClass]="displayItemsMode == 'grid' ? 'p-3' : 'p-2'" [mode]="displayItemsMode" [item]="item.products[0]"></product-card>
      }
      @if (item.isFamily) {
        <family-card #familyCard class="col d-flex p-3" [mode]="displayItemsMode" [item]="item.products[0]" [numFound]="item.numFound" (goTo)="goToFamily($event)"></family-card>
      }
      @if (item.isBucket) {
        <bucket-card class="col d-flex p-3" [item]="item.products[0]" [numFound]="item.numFound"></bucket-card>
      }
    }
  </div>
} @else {
  @if (!loading) {
    <div class="pull-left">
      <cms [title]="noResultsCms"></cms>
    </div>
  }
}
<ng-container *ngTemplateOutlet="Pagination; context: { isTop: false }"></ng-container>


<ng-template #Pagination let-isTop="isTop">
  @if (items && items.length) {
    <div class="pagination-row d-flex align-items-center"   [ngClass]="isTop ? 'justify-content-between' : 'justify-content-center'">
      <div class="pagination-container d-flex align-items-center justify-content-between" [ngClass]="{'w-100': isTop}">
        @if (isTop && !hideResultsPerPageSelect) {
          <div class="mr-auto ml-0 w-100 d-flex gap-3">
            <mat-label class="text-nowrap">Results Per Page</mat-label>
            <mat-select class="item-per-page-select w-auto" [(value)]="_itemsPerPage"  (selectionChange)="loadItemPerPage($event.value)">
              @for (num of itemPerPageSelect; track num) {
                <mat-option [value]="num">{{num}}</mat-option>
              }
            </mat-select>
          </div>
        }
        @if (totalItems>=_itemsPerPage && !isTop) {
          <ngb-pagination [collectionSize]="totalItems"
            (pageChange)="loadPage($event)"
            [maxSize]="4"
            [pageSize]="_itemsPerPage"
            [rotate]="true"
            [(page)]="page"
            aria-label="Pagination"
            class="mx-4 mt-3"
            >
          </ngb-pagination>
        }
      </div>
      @if (isTop && !sharedSvc.isMobileMode()) {
        <div class="view-switcher-container d-flex align-items-center justify-content-end position-absolute top-0">
          <div class="view-switcher rounded-pill d-flex align-items-center position-relative app-forth-bg h-100">
            <div
              class="view-option grid-view"
              [class.active]="displayItemsMode == 'grid'"
              [ngClass]="{'app-white-text':displayItemsMode=='grid'}"
              (click)="changeItemsDisplay('grid')">
              <span translate>Grid View</span>
            </div>
            <div
              class="view-option list-view"
              [class.active]="displayItemsMode == 'list'"
              [ngClass]="{'app-white-text':displayItemsMode=='list'}"
              (click)="changeItemsDisplay('list')">
              <span translate>List View</span>
            </div>
            <div
              class="active-indicator app-primary-bg position-absolute d-flex align-items-center rounded-pill"
              ngClass="{{'is-'+displayItemsMode}}">
            </div>
          </div>
        </div>
      }
    </div>
  }
</ng-template>
